<template>
  <div class="form__group" :style="cssProps">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "FormGroup",
  computed: {
    cssProps() {
      return {
        "--form-input-count": this.$slots.default.filter(
          vnode => vnode.tag !== undefined
        ).length,
      };
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/_variables.scss';
$formInputCount: var(--form-input-count);

.form__group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  > div {
    width: calc(
      (100% / #{$formInputCount}) -
        (#{$padding-xl} * ((#{$formInputCount} - 1) / #{$formInputCount}))
    );
  }

  @media (max-width: $mobile-hd-width) {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }
}
</style>
